module.exports = __webpack_public_path__ + "assets/img/fermented_dough.55396e12.png";